
import CartItem from '../../components/Cart/CartItem';
import { useCart } from '../../context/CartContext';
import { formatCurrency } from '../../utility/formatCurrency';
import data from '../../data.json'

const Cart = () => {

  const { cartItems, cartQuantity } = useCart();

  return (
    <div>
      <h1 className='Cart'>YOUR CART</h1>
      <div>
        <button className='ButtonOne'><a href="/courses">GET MORE COURSES</a></button>
        
        <button className='ButtonOne'><a href="/payment">CHECKOUT</a></button>
      </div>
      <div>
      {cartItems.length === 0 ?
          <div>
            <h1>No Courses Added!</h1>
        </div> : <div>
          <h3 className='Para'>You have selected {cartQuantity} Course!</h3>
        </div>}
        {cartItems.map((item) => (
          <CartItem key={item.id} {...item} />
        ))}
      </div>

      <div>
        <p className='Total'>Total {formatCurrency(cartItems.reduce((total, cartItem) => {
          const item = data.find(item => item.id === cartItem.id)
          return total + (item?.price || 0) * cartItem.quantity
        }, 0)
        )}</p>
      </div>
    </div>
  )
}

export default Cart